export const setSearch = (search) => {
  return {
    type: 'SET_SEARCH',
	search: search
  }
};

export const setFilterPending = (filterpending) => {
  return {
    type: 'SET_FILTERPENDING',
	filterpending: filterpending
  }
};

export const setFilterOdoo = (filterOdoo) => {
  return {
    type: 'SET_FILTERODOO',
	filterOdoo: filterOdoo
  }
};

export const setFilterRating = (filterRating) => {
  return {
    type: 'SET_FILTERRATING',
	filterRating: filterRating
  }
};